import { Container } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

const ErrorBoundaryPage = () => {
  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'errorBoundary' });
  return (
    <Container className="h-100 d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h1>{t('unexpectedError')}</h1>

        <p>{t('applicationRestart')}</p>

        <p>
          <Trans
            i18nKey="errorBoundary.problemPersistContact"
            ns="pages"
            components={{
              a: <a href="mailto:service@optainhealth.com">get in touch</a>,
            }}
          />
        </p>
      </div>
    </Container>
  );
};

export default ErrorBoundaryPage;
